export enum CookieKeys {
  GOOGLE_LOGIN_UUID = "googleLoginUUID",
  GOOGLE_LOGIN_UUID_DEV = "googleLoginUUID_DEV",
  GOOGLE_LOGIN_UUID_TEST = "googleLoginUUID_TEST",
  GOOGLE_LOGIN_UUID_PRELIVE = "googleLoginUUID_PRELIVE",
  BIOMETRICS_LOGIN_UUID = "biometricsLoginUUID",
  BIOMETRICS_LOGIN_UUID_DEV = "biometricsLoginUUID_DEV",
  BIOMETRICS_LOGIN_UUID_TEST = "biometricsLoginUUID_TEST",
  BIOMETRICS_LOGIN_UUID_PRELIVE = "biometricsLoginUUID_PRELIVE"
}
